import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import PulpoField from '../../../pulpo_visualizer/fields/PulpoField';
import PictureDraggable from './PictureDraggable';
import styles from './location.module.scss';
import editIcon from '../../../icons/edit.svg';
import Clickable from '../../../components/clickable/Clickable';

const LocationFields = ({
  locationList,
  info,
  onInfoChange,
  locationKey,
  withoutDepartments,
  subLocationCheckbox,
  withFloorPlan,
  icon,
  map,
  isRequiredTrue,
  showFormErrors,
  handleFieldErrorChanged,
  singleLocation,
  defaultLocation,
  location_marked,
  assetRegistry,
  fromSMS,
  title,
  sms_form,
  containerClassName,
  locimg,
  customStyles
}) => {
  const [openIndoor, setIndoor] = useState(false);
  const [savedStatus, setSavedStatus] = useState(false);
  const [savedPoint, setSavedPoint] = useState(undefined);
  let globalLocations = [];
  let selectedMap = '';
  let indoorMap = '';

  useEffect(() => {
    if (info?.location_marked) {
      setSavedPoint(info?.location_marked);
      setSavedStatus(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (withoutDepartments) {
    globalLocations = locationList;
  } else if (locationList && info?.departments && typeof info?.departments === 'object') {
    globalLocations = locationList.filter(loc => (
        loc.departments.filter(dept => (
          info?.departments?.filter(selDep => (selDep?.value?.toString() === dept?.id?.toString()))?.length > 0
        ))?.length > 0
    ));
  } else if (locationList && info?.departments) {
    globalLocations = locationList.filter(loc => (
        loc.departments.filter(dept => (dept?.id?.toString() === info?.departments?.toString()))?.length > 0
    ));
  }

  let levelOneValues = [];
  if (info?.global_location?.location) {
    levelOneValues = locationList.filter(
      value => (value?.[locationKey || 'id']?.toString() === info?.global_location?.location?.toString())
    );
    if (levelOneValues.length > 0) {
      levelOneValues = levelOneValues[0].location_levels;
    }
  }
  let levelTwoValues = [];
  if (info?.global_location?.location && info?.global_location?.location1 && levelOneValues?.length > 0) {
    levelTwoValues = levelOneValues.filter(
      (value) => {
        let checkVal = info?.global_location?.location1;
        if (value.location_code) {
          checkVal = info?.global_location?.location1.split(`${value.location_code} - `)[1];
        }
        return value?.title === checkVal;
      }
    );
    if (levelTwoValues.length > 0) {
      selectedMap = levelTwoValues[0]?.selected_map;
      indoorMap = levelTwoValues[0]?.attachment;
      levelTwoValues = levelTwoValues[0].level_1;
    }
  }
  let levelThreeValues = [];
  if (info?.global_location?.location1 && info?.global_location?.location2 && info?.global_location?.location && levelTwoValues?.length > 0) {
    levelThreeValues = levelTwoValues.filter(
      value => (value?.title === info?.global_location?.location2)
    );
    if (levelThreeValues.length > 0) {
      if (levelThreeValues[0]?.selected_map === 'airfield' || levelThreeValues[0]?.selected_map === 'indoor') {
        selectedMap = levelThreeValues[0]?.selected_map;
        indoorMap = levelThreeValues[0]?.attachment;
      }
      levelThreeValues = levelThreeValues[0].level_2;
    }
  }

  const handleAttachmentLocation = (e) => {
    if (!subLocationCheckbox) {
      const selectedLoc = levelOneValues.filter(
        value => (value?.title === e)
      )?.[0]?.selected_map;
      if (selectedLoc === 'indoor' && fromSMS) { setIndoor(true); }
      onInfoChange('selected_map', selectedLoc);
    }
    onInfoChange(
      'global_location',
      {
        ...info.global_location,
        location1: e,
        location2: '',
        location3: ''
      }
    );
  };

  const handleAttachmentLocLevel2 = (e) => {
    if (!subLocationCheckbox) {
      const selectedLoc = levelTwoValues.filter(
        value => (value?.title === e)
      )?.[0]?.selected_map;
      if (selectedLoc === 'indoor' && fromSMS) { setIndoor(true); }
      onInfoChange('selected_map', selectedLoc);
    }
    onInfoChange(
      'global_location',
      {
        ...info.global_location,
        location2: e,
        location3: ''
      }
    );
  };

  return (
    <>
      {globalLocations?.length > 0 && (
          <>
            <div className={containerClassName || styles.locations}>
              {!singleLocation && (
                <PulpoField
                  type="select"
                  answer={info?.global_location?.location}
                  translationID="inspections.step1.locations"
                  title={`${title || 'Locations'}`}
                  disabled={singleLocation || false}
                  handleValueChange={e => onInfoChange(
                    'global_location',
                    {
                      location: e,
                      location1: '',
                      location2: '',
                      location3: ''
                    }
                  )}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  values={
                    globalLocations.map(globLoc => (
                      { key: globLoc[locationKey] || globLoc.id, value: globLoc.name }
                    ))
                  }
                  isRequired={isRequiredTrue}
                  showFieldErrors={showFormErrors}
                  className={assetRegistry ? styles.paddingZero : ''}
                  customStyles={customStyles}
                />
              )}
              {(info?.global_location?.location) && levelOneValues?.length > 0 && (
                <PulpoField
                  type="select"
                  answer={info.global_location?.location1}
                  translationID="inspections.step1.location1"
                  title="Location - Level1"
                  handleValueChange={e => handleAttachmentLocation(e)}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  values={
                    levelOneValues.map(loc => (
                      { key: loc.location_code ? `${loc.location_code} - ${loc.title}` : loc.title,
                      value: loc.location_code ? `${loc.location_code} - ${loc.title}` : loc.title,
                      favourite: loc.favourite }
                    ))
                  }
                  isRequired={isRequiredTrue}
                  showFieldErrors={showFormErrors}
                  className={assetRegistry ? styles.paddingZero : ''}
                  customStyles={customStyles}
                />
              )}
            </div>
            <div className={containerClassName || styles.locations}>
                {info?.global_location?.location1 && levelTwoValues?.length > 0 && (
                <PulpoField
                  type="select"
                  answer={info.global_location?.location2}
                  translationID="inspections.step1.location2"
                  title="Location - Level2"
                  handleValueChange={e => handleAttachmentLocLevel2(e)}
                  handleFieldErrorChanged={() => {}}
                  values={
                    levelTwoValues.map(loc => (
                      { key: loc.title, value: loc.title, favourite: loc.favourite }
                    ))
                  }
                  className={assetRegistry ? styles.paddingZero : ''}
                  customStyles={customStyles}

                />
              )}
              {info?.global_location?.location2 && levelThreeValues?.length > 0 && (
                <PulpoField
                  type="select"
                  answer={info.global_location?.location3}
                  translationID="inspections.step1.location3"
                  title="Location - Level3"
                  handleValueChange={e => onInfoChange(
                    'global_location',
                    {
                      ...info.global_location,
                      location3: e
                    }
                  )}
                  handleFieldErrorChanged={() => {}}
                  values={
                    levelThreeValues.map(loc => (
                      { key: loc.title, value: loc.title, favourite: loc.favourite }
                    ))
                  }
                  customStyles={customStyles}


                />
              )}
            </div>
            {withFloorPlan && (
              <>
                {selectedMap === 'airfield' && (
                  <div className={styles.fullWidth}>
                    <PulpoField
                      key="location"
                      id="location"
                      type="location"
                      translationID="workorder.create.location"
                      title="Location"
                      isRequired={isRequiredTrue}
                      noPolygon
                      handleValueChange={(a, b) => onInfoChange(b, a)}
                      answer={info.location || defaultLocation}
                      showFieldErrors={showFormErrors}
                      map_style={map?.map_style}
                      mapbox_style={map?.mapbox_style || sms_form?.mapbox_style}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                      customStyles={customStyles}

                    />
                  </div>
                )}
                {selectedMap === 'indoor' && (
                  fromSMS
                ? <>
                    {info?.location_marked?.x > 0 && info?.location_marked?.y > 0 && indoorMap
                    ? <div style={{ position: 'relative' }}>
                        <PictureDraggable
                          attachment={indoorMap}
                          position={info?.location_marked ?? location_marked}
                          handleSave={() => { setIndoor(false); setSavedStatus(true); setSavedPoint(info?.location_marked || location_marked); }}
                          handleSavedStatus={() => setSavedStatus(true)}
                          savedStatus={savedStatus}
                          savedPoint={savedPoint}
                          handleDisplay={() => setIndoor(false)}
                          location={info.global_location?.location}
                          locDetail
                          fromSMS
                          responsiveScroll
                        />
                        <Clickable onClick={() => { setIndoor(true); setSavedStatus(false); }}>
                          <div className={styles.editLocation}>
                            <img src={editIcon} alt="info" width="17px" height="17px" style={{ marginRight: '8px' }} />
                            Edit Location
                          </div>
                        </Clickable>
                      </div>
                    : <>
                        <div className={styles.warning}>
                          No location is selected
                        </div>
                        <div style={{ position: 'relative' }}>
                          <img src={indoorMap?.url} alt={indoorMap?.name || ''} width="736px" height="243px" style={locimg ?? {}} />
                          <Clickable onClick={() => { setIndoor(true); setSavedStatus(false); }}>
                            <div className={styles.editLocation}>
                              <img src={editIcon} alt="info" width="17px" height="17px" style={{ marginRight: '8px' }} />
                              Edit Location
                            </div>
                          </Clickable>
                        </div>
                      </>
                    }
                  </>
                : <Clickable onClick={() => { setIndoor(true); setSavedStatus(false); }}>
                    <img src={indoorMap?.url} alt={indoorMap?.name || ''} width="736px" height="243px" style={locimg ?? {}} />
                  </Clickable>
                )}
                {indoorMap && openIndoor && (
                  <div className={styles.fullInput}>
                    <PictureDraggable
                      attachment={indoorMap}
                      position={info?.location_marked ?? location_marked}
                      handleAnswerChanged={(section, value, id) => onInfoChange(id, value)}
                      handleSave={() => { setIndoor(false); setSavedStatus(true); setSavedPoint(info?.location_marked || location_marked); }}
                      handleSavedStatus={() => setSavedStatus(true)}
                      savedStatus={savedStatus}
                      savedPoint={savedPoint}
                      handleDisplay={() => setIndoor(false)}
                      location={info.global_location?.location}
                      display={openIndoor}
                      icon={icon}
                      fromSMS={fromSMS}
                      responsiveScroll={fromSMS}
                    />
                  </div>
                )}
              </>
            )}
            {subLocationCheckbox && (
              <div className={styles.extra}>
                <div className={styles.inlineCheckbox}>
                  <div>
                    <input
                      defaultChecked={info?.all_sublocations}
                      type="checkbox"
                      className={styles.inputStyle}
                      onChange={e => onInfoChange('all_sublocations', e.nativeEvent.target.checked)
                      }
                    />
                    <FormattedMessage
                      id="inspection.step1.apply_locs"
                      defaultMessage="Apply to all sub Locations"
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
    </>
  );
};

LocationFields.propTypes = {
  onInfoChange: PropTypes.func.isRequired,
  info: PropTypes.shape({}).isRequired,
  handleFieldErrorChanged: PropTypes.func,
  isRequiredTrue: PropTypes.shape(Boolean),
  showFormErrors: PropTypes.shape(Boolean),
  containerClassName: PropTypes.string
};

LocationFields.defaultProps = {
  handleFieldErrorChanged: () => {},
  isRequiredTrue: false,
  showFormErrors: false,
  containerClassName: ''
};

export default LocationFields;
